import { render } from "./TheGrid.vue?vue&type=template&id=3b2f59bb&scoped=true"
import script from "./TheGrid.vue?vue&type=script&lang=js"
export * from "./TheGrid.vue?vue&type=script&lang=js"

import "./TheGrid.vue?vue&type=style&index=0&id=3b2f59bb&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2f59bb"]])

export default __exports__